module.exports = __webpack_public_path__ + "static/img/brid-box.a4d2d063.png";